<template>
    <b-modal ref="mdlDizionarioEdit" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Tipo</label>
                <b-form-select :options="tipoOptions" v-model="jsonDataDizionario.tipo" value="''" value-field="value" text-field="text" required>
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Tipologia - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Voce</label>
                <b-form-input v-model="jsonDataDizionario.voce" required></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonDataDizionario.note" max-rows="10" rows="7"></b-form-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button size="md" variant="outline-success" @click="onClickSaveVoceDizionario()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: {
        ModalError,
    },
    data() {
        return {
            pathResourceDizionario: "/rsadizionario",
            title: null,
            jsonDataDizionario: {
                id: null,
                tipo: null,
                voce: null,
                note: null,
            },
            tipoOptions: [
                { text: "AUSILIO", value: "AUSILIO" },
                { text: "ASSISTENZA", value: "ASSISTENZA" },
                { text: "REAZIONI DI DIFESA", value: "REAZIONI_DIFESA" },
                { text: "SIEROLOGIA", value: "SIEROLOGIA" },
                { text: "ALLERGIA", value: "ALLERGIA" },
                { text: "RIABILITAZIONE TECNICA", value: "RIABILITAZIONE_TECNICA" },
                { text: "RIABILITAZIONE OBIETTIVO", value: "RIABILITAZIONE_OBIETTIVO" },
                { text: "CUTE", value: "CUTE" },
                { text: "ADL", value: "ADL" },
                { text: "UNGHIE", value: "UNGHIE" },
                { text: "EDEMI", value: "EDEMI" },
                { text: "AUSILIO P.V.", value: "AUfeddweedsfggffdddSILIO_PARAM_VITALI" },
                { text: "MOTIVAZIONE PRESENZE/USCITE", value: "MOTIVAZIONE_PRESENZE_USCITE" },
                { text: "MOTIVAZIONE DIMISSIONE/TRASFERIMENTO", value: "MOTIVAZIONE_DIMISSIONE_TRASFERIMENTO" },
                { text: "STATO SPESA EXTRA", value: "STATO_SPESA_EXTRA" },
            ],
        };
    },
    methods: {
        onCloseModal() {
            let me = this;
            me.jsonDataDizionario = {};
            me.$refs.mdlDizionarioEdit.hide();
            me.$emit("onCloseModal");
        },
        show(jsonData) {
            let me = this;
            me.jsonDataDizionario = jsonData;
            me.title = !jsonData.id ? "Crea Voce Dizionario" : "Aggiorna Voce Dizionario";
            me.$refs.mdlDizionarioEdit.show();
        },
        deleteVoceDizionario(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResourceDizionario + "/" + id, null, me.deleteVoceDizionarioSuccess, me.deleteVoceDizionarioError);
        },
        deleteVoceDizionarioSuccess(response) {
            let me = this;
            me.$emit("deleteVoceDizionario", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
        },
        deleteVoceDizionarioError(response) {
            let me = this;
            me.$emit("deleteVoceDizionario", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Error",
                variant: "error",
                solid: true,
            });
        },
        onDeleteVoceDizionario(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa voce?", {
                    title: "Eliminazione voce",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) me.deleteVoceDizionario(item.id);
                })
                .catch((error) => {
                    console.error("Errore durante l'eliminazione: ", error);
                });
        },
        onClickSaveVoceDizionario(/*bvModalEvent*/) {
            //Da usare se non si usa il footer della modale personalizzato.
            // Prevenire la chiusura automatica per validare i campi
            /* bvModalEvent.preventDefault(); */
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResourceDizionario, me.jsonDataDizionario, me.saveVoceDizionarioSuccessResponse, me.saveVoceDizionarioErrorResponse);
        },
        saveVoceDizionarioSuccessResponse(response) {
            let me = this;
            me.$emit("saveVoceDizionario", response);
            me.$refs.mdlDizionarioEdit.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveVoceDizionarioErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
